import { Widget } from '@/modules/ta/widget/models/Widget';
import { WidgetDataCache } from '@/modules/ta/widget/caches/WidgetDataCache';

export class MediaWidget extends Widget {
  constructor(model = {}) {
    super(model);
    this.cached_data = model.cached_data;
    WidgetDataCache.set(this.id, this.cached_data);
  }
}
